import React from 'react';
import '../../styles/components/warning-box.scss';
import { AlertTriangle } from 'lucide-react';
import i18n from '../../i18n';

export class WarningBox extends React.Component {
  handleApprove = () => {
    if (this.props.onApprove) {
      this.props.onApprove();
    }
  };

  handleReject = () => {
    if (this.props.onReject) {
      this.props.onReject();
    }
  };

  render() {
    const { message, onReject, approveText, rejectText } = this.props;
    return (
      <div className="warning-box">
        <div className="warning-content">
          <div className="warning-icon">
            <AlertTriangle size={22} color="#ffb400" />
          </div>
          <div className="warning-message">
            {message || 'Refund Warning. Please review carefully before proceeding.'}
          </div>
          <div className="warning-buttons">
            <button className="btn-approve" onClick={() => this.handleApprove()}>
              {approveText || i18n.t('approve')}
            </button>
            {/* Reject only shows if onReject prop exists */}
            {onReject && (
              <button className="btn-reject" onClick={this.handleReject}>
                {rejectText || i18n.t('reject')}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
